export default {
  platform: {
    1: {
      value: 1,
      name: 'android',
      icon: 'icon-android-r',
    },
    2: {
      value: 2,
      name: 'ios',
      icon: 'icon-iOS-r',
    },
    4: {
      value: 4,
      name: 'windows',
      icon: 'icon-windows-r',
    },
    16: {
      value: 16,
      name: 'html5',
      icon: 'icon-html-r',
    },
    32: {
      value: 32,
      name: 'weichat',
      icon: 'icon-miniprogram-r',
    },
    64: {
      value: 64,
      name: 'quickapp',
      icon: 'icon-kuaiyingyongSDK',
    },
  },

  getIconToNameMap() {
    const retMap = {};
    for (const key in this.platform) {
      if (Object.hasOwnProperty.call(this.platform, key)) {
        const platObj = this.platform[key];
        retMap[platObj.icon] = platObj.name;
      }
    }
    return retMap;
  },

  getValueToNameMap() {
    const retMap = {};
    for (const key in this.platform) {
      if (Object.hasOwnProperty.call(this.platform, key)) {
        const platObj = this.platform[key];
        retMap[platObj.value] = platObj.name;
      }
    }
    return retMap;
  }
}